import { type ProductBySlugResponse } from '@/modules/product/aliases';
import { isPLAReferer } from '@/modules/product/helpers/isPLAReferer';
import { isSold } from '@/modules/product/helpers/isSold';

export function shouldRenderSimilarSash({
  product,
  params,
  referer,
}: {
  product?: ProductBySlugResponse;
  params: Record<string, string>;
  referer: string | null;
}) {
  const sold = product ? isSold(product.status) : false;

  return sold || isPLAReferer({ params: new URLSearchParams(params), referer });
}
